export const cognitoConstants = {
  aws_project_region: "ap-northeast-1",
  aws_cognito_identity_pool_id: "",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_JksFzKW8Y",
  aws_user_pools_web_client_id: "6qo7gvch81ff68ej59vr9gq824",
};
